<template>
    <div class="section-categoryBarBox" id="bar" v-if="allowedItems.length">
        <div class="christmas__header" v-if="isChristmas"></div>
        <div class="easter__header" v-if="isEaster"></div>

        <div class="section-categoryBarCont" :class="{scroll:offsetBarTop}">
            <div class="section-categoryBarBgg">
                <div class="section-categoryBar">
                    <div class="section-categoryBar__menu">
                        <swiper ref="swiperSS" class="list" :options="settingsMenu" :initialSlide="items.length"
                                :rtl="this.$store.state.rtl">
                            <swiper-slide class="list__item" :id="item.htmlId" :class="item.htmlClass"
                                          v-for="(item, index) in allowedItems" :key="index">
                                <router-link v-if="!item.url" :to="item.pageUrl" :target="item.htmlTarget">
                                    <picture v-if="item.image.jpg">
                                        <source :srcset="item.image[sourceType]" :type="`image/${sourceType}`"
                                                v-for="(sourceType, index) in item.image.sourcesTypes" :key="index">
                                        <img :src="item.image.jpg" :alt="item.title"/>
                                    </picture>
                                    {{ item.title }}
                                </router-link>
                                <a v-else :href="item.url" :target="item.htmlTarget">
                                    <picture v-if="item.image.jpg">
                                        <source :srcset="item.image[sourceType]" :type="`image/${sourceType}`"
                                                v-for="(sourceType, index) in item.image.sourcesTypes" :key="index">
                                        <img :src="item.image.jpg" :alt="item.title"/>
                                    </picture>
                                    {{ item.title }}
                                </a>
                            </swiper-slide>
                        </swiper>
                        <div id="button-next-relacionados" class="swiper-button-next swiper-button-white"
                             @click="swiperNext()"></div>
                        <div id="button-prev-relacionados" class="swiper-button-prev swiper-button-white"
                             @click="swiperPrev()"></div>
                    </div>
                    <search-catalog-bar/>
                </div>
            </div>
        </div>

        <div class="halloween__header" v-if="isHalloween">
            <img src="/public/halloween/spiders.png" alt="Halloween">
        </div>
    </div>
</template>

<script>
import {events} from "../../../../../config/app";
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

export default {
    name: "HorizontalBarWithSearch",

    components: {
        Swiper,
        SwiperSlide,
    },

    props: ['items'],

    data: function () {
        return {
            updateScrollTimeout: undefined,
            innerWidth: undefined,
            offsetBarTop: false,
            settingsMenu: {
                init: true,
                slidesPerView: 'auto',
                threshold: 5,
                updateOnWindowResize: true,
                watchOverflow: true,
                speed: 200,
                navigation: {
                    nextEl: '#button-next-relacionados',
                    prevEl: '#button-prev-relacionados',
                },
            },
        };
    },

    mounted() {
        this.innerWidth = window.innerWidth;

        window.addEventListener('scroll', this.setUpdateScrollTimeout);

        this.setUpdateScrollTimeout();
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.setUpdateScrollTimeout);
    },

    computed: {
        isHalloween() {
            return events.halloween;
        },

        isChristmas() {
            return events.christmas;
        },

        isEaster() {
            return events.easter;
        },

        allowedItems() {
            return this.items || [];
        },

        locale() {
            return this.$store.state.locale;
        },

        swiper() {
            return this.$refs.swiperSS.$swiper
        },
    },

    methods: {
        setUpdateScrollTimeout(){
            if (!this.updateScrollTimeout){
                this.updateScrollTimeout = setTimeout(this.updateScroll, 100);
            }
        },

        swiperNext() {
            this.$refs.swiperSS.$swiper.slideNext()
        },

        swiperPrev() {
            this.$refs.swiperSS.$swiper.slidePrev()

        },

        updateScroll() {
            clearTimeout(this.updateScrollTimeout);
            this.updateScrollTimeout = null;

            let bar = document.getElementById('bar');

            if (bar) {
                this.offsetBarTop = bar.getBoundingClientRect().top <= 63;
            }
        },
    },
}
</script>

<style lang="sass">
@import "sass/components/pages/parts/menus/HorizontalBarWithSearch"
</style>
